import React, { memo, useMemo } from 'react';
import { View } from 'react-native';
import { rem } from 'design-system';
import SectionHeader from 'design-system/SectionHeader';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import { useMarginBottom } from 'hooks/useMarginBottom';
import CorporateEventRow from './CorporateEventRow';
const CorporateEventsSectionRow = ({ item }) => {
    const styles = useStyles(styleSet);
    const marginBottomStyles = useMarginBottom();
    const borderStyles = useMemo(() => [item.isLastInSection && styles.lastItem, item.isFirstInSection && styles.firstItem], [item.isLastInSection, item.isFirstInSection, styles.lastItem, styles.firstItem]);
    if ('sectionTitle' in item) {
        return (<SectionHeader horizontalMargins largeVerticalMargins>
        {item.sectionTitle}
      </SectionHeader>);
    }
    if ('lastElement' in item) {
        return <View style={marginBottomStyles}/>;
    }
    return (<View style={[styles.wrapper, borderStyles]}>
      <CorporateEventRow event={item}/>
    </View>);
};
export default memo(CorporateEventsSectionRow);
const styleSet = createStyleSheets((colors) => ({
    wrapper: {
        marginHorizontal: rem(16),
        backgroundColor: colors.cards.onDark,
    },
    firstItem: {
        borderTopLeftRadius: rem(16),
        borderTopRightRadius: rem(16),
    },
    lastItem: {
        borderBottomLeftRadius: rem(16),
        borderBottomRightRadius: rem(16),
    },
}));
